// extracted by mini-css-extract-plugin
export default {"scheduledOrderHeader":"_0aYKV0G1--OnloadPopUps_scheduledOrderHeader__7Xzwv","wiggle":"_0aYKV0G1--OnloadPopUps_wiggle__+KtlE","shimmer":"_0aYKV0G1--OnloadPopUps_shimmer__Igx9i"};